import React, { useEffect, useState } from "react";
import { getPageVersions, restorePageVersion } from "../../../../api/pageVersionApi";

export default function VersionsModal({ slug, onClose, onRestored }) {
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    getPageVersions(slug).then((res) => {
      setVersions(res.data);
    });
  }, [slug]);

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex justify-center items-center">
      <div className="bg-white w-full max-w-lg p-6 rounded">
        <h2 className="text-xl font-bold mb-4">Histórico de versões</h2>

        <ul className="space-y-3 max-h-80 overflow-auto">
          {versions.map((v) => (
            <li key={v.id} className="flex justify-between items-center border-b pb-2">
              <span>{new Date(v.created_at).toLocaleString()}</span>
              <button
                className="btn-secondary"
                onClick={async () => {
                  await restorePageVersion(slug, v.id);
                  onRestored();
                  onClose();
                }}
              >
                Restaurar
              </button>
            </li>
          ))}
        </ul>

        <div className="flex justify-end mt-6">
          <button onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}
